import React, { useState } from 'react';
import './ProductCard.css';

function ProductCard({ product, addToCart }) {
  const [selectedSize, setSelectedSize] = useState(product.sizes[0]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showNotification, setShowNotification] = useState(false);
  const [showSizeChart, setShowSizeChart] = useState(false);

  const handleAddToCart = () => {
    const price = product.priceOptions
      ? product.priceOptions[selectedSize]
      : product.price;

    addToCart({
      id: product.id,
      name: product.name,
      size: selectedSize,
      price: price,
      shipping: product.shipping
    });

    setShowNotification(true);
    setTimeout(() => {
      setShowNotification(false);
    }, 3000);
  };

  const currentPrice = product.priceOptions
    ? product.priceOptions[selectedSize]
    : product.price;

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === product.images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? product.images.length - 1 : prevIndex - 1
    );
  };

  const getSizeChartContent = () => {
    if (product.id === 3) {
      return (
        <div className="size-chart-content">
          <h3>Sticker Sizes</h3>
          <div className="size-info">
            <p><strong>2" x 2"</strong> - Perfect for laptops, water bottles, phone cases</p>
            <p><strong>4" x 4"</strong> - Great for notebooks, car windows, larger surfaces</p>
          </div>
        </div>
      );
    }
    return (
      <div className="size-chart-content">
        <h3>Size Chart - {product.name}</h3>
        <table className="size-table">
          <thead>
            <tr>
              <th>Size</th>
              <th>Chest (inches)</th>
              <th>Length (inches)</th>
            </tr>
          </thead>
          <tbody>
            <tr><td>Youth S</td><td>14-15</td><td>20-21</td></tr>
            <tr><td>Youth M</td><td>16-17</td><td>22-23</td></tr>
            <tr><td>Youth L</td><td>18-19</td><td>24-25</td></tr>
            <tr><td>Adult S</td><td>34-36</td><td>28</td></tr>
            <tr><td>Adult M</td><td>38-40</td><td>29</td></tr>
            <tr><td>Adult L</td><td>42-44</td><td>30</td></tr>
            <tr><td>Adult XL</td><td>46-48</td><td>31</td></tr>
            <tr><td>Adult XXL</td><td>50-52</td><td>32</td></tr>
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="product-card">
      {showNotification && (
        <div className="cart-notification">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
          <span>Added {product.name} ({selectedSize}) to cart!</span>
        </div>
      )}
      <div className="polaroid-frame">
        <div className="polaroid-image">
          <img src={product.images[currentImageIndex]} alt={`${product.name} - view ${currentImageIndex + 1}`} />

          {product.images.length > 1 && (
            <>
              <button className="carousel-btn carousel-btn-prev" onClick={prevImage} aria-label="Previous image">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
              </button>
              <button className="carousel-btn carousel-btn-next" onClick={nextImage} aria-label="Next image">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </button>

              <div className="carousel-indicators">
                {product.images.map((_, index) => (
                  <button
                    key={index}
                    className={`indicator ${index === currentImageIndex ? 'active' : ''}`}
                    onClick={() => setCurrentImageIndex(index)}
                    aria-label={`Go to image ${index + 1}`}
                  />
                ))}
              </div>
            </>
          )}
        </div>

        <div className="polaroid-caption">
          <h3 className="product-name">{product.name} - <span className="product-description">{product.description}</span></h3>
          {product.availability && (
            <p className="product-availability">{product.availability}</p>
          )}
          <div className="product-pricing">
            <p className="price">${currentPrice.toFixed(2)} + ${product.shipping.toFixed(2)} for shipping/handling</p>
          </div>
        </div>
      </div>

      <div className="product-controls">
        <div className="size-selector">
          <div className="size-selector-header">
            <label htmlFor={`size-${product.id}`}>Size:</label>
            <button
              className="size-chart-btn"
              onClick={() => setShowSizeChart(true)}
              type="button"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="3" y1="9" x2="21" y2="9"></line>
                <line x1="9" y1="21" x2="9" y2="9"></line>
              </svg>
              Size Chart
            </button>
          </div>
          <select
            id={`size-${product.id}`}
            value={selectedSize}
            onChange={(e) => setSelectedSize(e.target.value)}
          >
            {product.sizes.map(size => (
              <option key={size} value={size}>{size}</option>
            ))}
          </select>
        </div>

        <button className="add-to-cart-btn" onClick={handleAddToCart}>
          Add to Cart
        </button>
      </div>

      {showSizeChart && (
        <div className="size-chart-modal" onClick={() => setShowSizeChart(false)}>
          <div className="size-chart-dialog" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setShowSizeChart(false)}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
            {getSizeChartContent()}
          </div>
        </div>
      )}
    </div>
  );
}

export default ProductCard;
